import { render, staticRenderFns } from "./AppBarClearCache.vue?vue&type=template&id=6a6b3312"
import script from "./AppBarClearCache.vue?vue&type=script&lang=js"
export * from "./AppBarClearCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports